import * as axiosBaseClient from './axiosBaseClient';
import configurations from '../config.json';
import { apiUrl } from "../httpCommon";

const baseURL = apiUrl();

export const getADSDataByEmail = (emailId) => {
    const url = `${baseURL}/${configurations.LDAP_END_POINT}?emailId=${emailId}`;
    return axiosBaseClient.httpGet(url);
  };